<template>
    <div class="float-left">
        <b-button
        variant="success"
        @click="abrirModal()">
            Adicionar Despesa
        </b-button>
        <despesa-sebrae-form
            operacaoProp="I"
            :pleito="pleito"
            :mostrarModal="mostrarModal"
            :erros="erros"
            :dataServicos="dataServicos"
            @fechar="fecharModal()"
            @salvar="salvar($event)"
        ></despesa-sebrae-form>
    </div>
</template>

<script>
import DespesaSebraeForm from './DespesaSebraeForm'

export default {
    components: {
        DespesaSebraeForm
    },

    props: {
        pleito: {
            type: Object,
        },
        dataServicos: {
            type: Object
        },
    },

    data() {
        return {
            mostrarModal: false,
            erros: [],
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        salvar(despesa){
            this.$store.dispatch('addRequest')
            let despesaDto = {
                pleitoId : despesa.pleitoId,
                acaoId: despesa.acaoId,
                descritivo: despesa.descritivo,
                proposta: despesa.proposta,
                codTipoNatureza: despesa.codigoNaturezaDespesa,
                valorTotal: despesa.valorTotal,
                tipoDoRecurso: despesa.tipoRecurso,
                fonteDoRecurso: despesa.fonteRecurso,
            }
            this.dataServicos.inserirDespesaSebrae(despesaDto)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Despesa inserida com sucesso',
                            'OK',
                            this.$toastConfig.success)
                        this.$emit('atualizarLista')
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
            this.fecharModal()
        },
    }
}
</script>
